const EventsDetail = () => import('Views/dataCatalog/laboratory/laboratory');

export default[
  { path: '/laboratory/:id',
    component: EventsDetail,
    meta: {
      title: '数据目录',
      hideHeader: true,
      hideAside: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/laboratory.js